import { Component, Input } from '@angular/core';
import { ICertificadoDeVigencia, IDatosBasicosSolicitud } from 'src/app/models/empresa-en-un-dia/empresa-en-un-dia.model';

@Component({
  selector: 'app-vigencia-viewer',
  templateUrl: './vigencia-viewer.component.html',
  styleUrls: ['./vigencia-viewer.component.scss']
})
export class VigenciaViewerComponent {
    @Input() content!: ICertificadoDeVigencia;
    @Input() datosBasicosSolicitud!: IDatosBasicosSolicitud;
    @Input() showHeader = true;

    public rut = '';
    public today = '';

    ngOnInit(): void {
        this.setToday();
        this.setRut();
    }

    setRut() {
        this.rut = this.datosBasicosSolicitud.Rut + '-' + this.datosBasicosSolicitud.DV
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }
}
